import PositioningDeviceFittingsTypeAddProcessremarkModal from './positioning-device-fittings-type-add-processremark-modal.vue'
export default PositioningDeviceFittingsTypeAddProcessremarkModal
